import { render, staticRenderFns } from "./login-callback.page.vue?vue&type=template&id=44b33292&"
import script from "./login-callback.page.vue?vue&type=script&lang=js&"
export * from "./login-callback.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports